<template>
  <table class="caption-bottom table table-light table-sm">
    <caption class="bg-light text-dark">
      <div class="d-flex justify-content-between p-2 mt-4">
        <span>
          شماره فاکتور:
          {{ order.id }}
        </span>
        <span>
          مبلغ کل:
          {{ this.utils.monize(order.amount) }}
        </span>

        <span>
          تاریخ:
          {{ this.utils.toJalali(order.created_at) }}
        </span>

        <span>
          کاربر:
          {{ order.user.first_name }} {{ order.user.last_name }} -
          {{ order.user.email }}
        </span>
      </div>
      <div class="d-flex justify-content-between p-2">
        <span>
          وضعیت:
          {{ order.order_status === "ok" ? "درگاه" : "" }}
          {{ order.order_status === "manual_ok" ? "دستی" : "" }}
        </span>
        <span>
          توضیحات:
          {{ order.comment ? order.comment : "--" }}
        </span>

        <span>
          شماره کارت:
          <span dir="ltr">
            {{
              order.payments.length
                ? JSON.parse(order.payments[0].bank_returned).CardHolderPan
                : "--"
            }}
          </span>
        </span>

        <span>
          کد رهگیری بانک:
          {{
            order.payments.length ? order.payments[0].sale_reference_id : "--"
          }}
        </span>
      </div>
    </caption>
    <thead>
      <tr>
        <th class="text-start">محصول</th>
        <th>کد</th>
        <th>تعداد</th>
        <th>قیمت واحد</th>
        <th>تخفیف</th>
        <th>بازگشت از خرید</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="item in order.orderDetail" :key="item.id">
         <template v-if="item.product.type === 'chairs'">
          <tr class="align-middle">
            <td class="text-start">
              <img
                style="width: 30px"
                :src="API_STORAGE_URL + item.product.main_image_thumb_path"
                @error="noPic"
              />
              {{ item.product.name }}
              <div> شماره صندلی/ها:
                <span class="badge bg-warning text-dark me-1" v-for="record in item.productDetails" :key="record.id">
                  {{ record.chair_number }}
                </span>
              </div>
            </td>
            <td>
              {{ item.product.id }}
            </td>
            <td>
              {{ item.number }}
            </td>
            <td>
              {{ this.utils.monize(item.price) }}
              تومان
            </td>
            <td>
              {{ item.coupon ? item.coupon.name : "" }}
            </td>
            <td>
              <button
                v-if="!item.refund"
                class="btn btn-warning btn-sm"
                @click="cancelProduct(item.product.id)"
              >
                بازگشت از خرید
              </button>
              <span v-else class="text-danger">
                مرجوع شده توسط
                {{ item.refund.user ? item.refund.user.first_name : "" }}
                {{ item.refund.user ? item.refund.user.last_name : "" }}
                در
                {{ this.utils.toJalali(item.refund.created_at) }}
              </span>
            </td>
          </tr>
        </template>
        <template v-else-if="item.all_videos_buy">
          <tr class="align-middle">
            <td class="text-start">
              <img
                style="width: 30px"
                :src="API_STORAGE_URL + item.product.main_image_thumb_path"
                @error="noPic"
              />
              {{ item.product.name }}
              {{ item.product.type === "video" ? "- دوره کامل" : "" }}
            </td>
            <td>
              {{ item.product.id }}
            </td>
            <td>
              {{ item.number }}
            </td>
            <td>
              {{ this.utils.monize(item.price) }}
              تومان
            </td>
            <td>
              {{ item.coupon ? item.coupon.name : "" }}
            </td>
            <td>
              <button
                v-if="!item.refund"
                class="btn btn-warning btn-sm"
                @click="cancelProduct(item.product.id)"
              >
                بازگشت از خرید
              </button>
              <span v-else class="text-danger">
                مرجوع شده توسط
                {{ item.refund.user ? item.refund.user.first_name : "" }}
                {{ item.refund.user ? item.refund.user.last_name : "" }}
                در
                {{ this.utils.toJalali(item.refund.created_at) }}
              </span>
            </td>
          </tr>
        </template>

        <template v-else>
          <template
            v-for="itemDetails in item.productDetails"
            :key="itemDetails.productDetailVideo.id"
          >
            <tr class="align-middle">
              <td class="text-start">
                <img
                  style="width: 30px"
                  :src="API_STORAGE_URL + item.product.main_image_thumb_path"
                  @error="noPic"
                />
                جلسه
                {{ itemDetails.numName }}
                -
                {{ item.product.name }}
              </td>
              <td>
                {{ itemDetails.productDetailVideo.id }}
              </td>
              <td>1</td>
              <td>
                {{ this.utils.monize(itemDetails.price) }}
                تومان
              </td>
              <td>
                <button
                  v-if="!itemDetails.refund"
                  class="btn btn-warning btn-sm"
                  @click="
                    cancelProductDetail(
                      item.product.id,
                      itemDetails.productDetailVideo.id
                    )
                  "
                >
                  بازگشت از خرید
                </button>
                <span v-else class="text-danger">
                  مرجوع شده
                  {{ item.refund.user.first_name }}
                  {{ item.refund.user.last_name }}
                  در
                  {{ item.refund.created_at }}
                </span>
              </td>
            </tr>
          </template>
        </template>
      </template>
    </tbody>
  </table>
</template>
<script>
import arefApi from "../libs/api";
import utils from "../libs/utils";

export default {
  name: "OrderDetails",
  props: {
    order: Object,
  },
  data() {
    return {};
  },

  created() {
    this.arefApi = new arefApi();
    this.utils = new utils();
    this.API_STORAGE_URL = process.env.VUE_APP_API_STORAGE_URL;
  },
  components: {},
  methods: {
    noPic(e) {
      e.target.src =
        process.env.VUE_APP_API_STORAGE_URL + process.env.VUE_APP_NO_IMAGE_URL;
    },
    cancelProduct(productId) {
      const cancelObj = {
        users_id: this.order.user.id,
        products_id: productId,
      };

      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .cancelBuyingProduct(cancelObj)
              .then(() => {
                this.utils.showSuccess(this);
                this.$emit("refreshPage");
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    cancelProductDetail(productId, productDetailId) {
      const cancelObj = {
        users_id: this.order.user.id,
        products_id: productId,
        product_detail_videos_id: productDetailId,
      };
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .cancelBuyingProductDetail(cancelObj)
              .then(() => {
                this.utils.showSuccess(this);
                this.$emit("refreshPage");
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
  },
};
</script>
